module.exports = __webpack_public_path__ + "img/certif_07.15bb6053.jpg";